import React from "react";

import "../styles/inputTable.scss";
import Select from "react-select";
import SelectStyles from "./SelectStyles";
import AppDatePicker from "../common/AppDatePicker";
import LabelInput from "./LabelInput";
export default function InputTable({
  headers,
  list,
  onInputChange,
  addNewRow,
  dataList,
  edit = true,
  data = [],
  helpText,
  onClick,
  helpFunction,
  className,
  theadStyle,
  SideButtons,
  noHeaders,
  id,
}) {
  const ip = [];
  const handlePress = (
    event,
    ref,
    validation,
    row,
    searchValidation,
    multiline
  ) => {
    // You can pass you validation query to the validation callback function, i have passed an array

    const key = event.keyCode;
    helpFunction && helpFunction(event.value || event, data, row, list);
    if (searchValidation) {
      if (validation && validation(event, dataList, data, row, list) === false)
        return false;
      ip[++ref] && ip[ref].current.focus();
      if (key === 13 && ref === ip.length) {
        addNewRow && addNewRow(ref);
        event.preventDefault();
      }
    }

    if (key === 13 || key === 39) {
      if (validation && validation(event, dataList, data, row, list) === false)
        return false;
      if (multiline) return false;

      ip[++ref] && ip[ref].current.focus();
      if (key === 13 && ref === ip.length) {
        addNewRow && addNewRow(ref);
        event.preventDefault();
      }
    } else if (key === 37) ip[--ref] && ip[ref].current.focus();
    else if (key === 38)
      ip[ref - headers.length] && ip[ref - headers.length].current.focus();
    else if (key === 40)
      ip[ref + headers.length] && ip[ref + headers.length].current.focus();
  };

  const filterOption = ({ value }, string) => {
    const word = string.toLowerCase().split(" ");
    const customList =
      value.toLowerCase().indexOf(word[word.length - 1]) !== -1;
    return customList;
  };

  return (
    <div className="container">
      <table id={id || "x-table"} className={className || `table `}>
        {!noHeaders && (
          <thead>
            <tr className="text-center" style={theadStyle}>
              <th></th>
              {headers.map(({ label, style }, n) => (
                <th style={style} key={n.toString()}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {list.map((row, index) => {
            return (
              <tr key={index + ""} className="body-tr">
                <td style={{ minWidth: 50 }} className="text-center">
                  {index + 1}
                </td>
                {row.map((dt, n) => {
                  const {
                    value,
                    name,
                    numberFormat,
                    noDigits,
                    condition,
                    searchValidation = false,
                    validation,
                    readOnly,
                    datePicker,
                    borderColor,
                    cell,
                    focusOn,
                    multiline,
                    ...rest
                  } = dt;

                  const ipLen = ip.length;
                  ip[ipLen] = React.createRef();
                  const dtl = dataList && dataList.find((i) => i.name === name);

                  if (dtl) {
                    return (
                      <td key={`${index}-${n}`}>
                        <Select
                          defaultValue={"Item Code"}
                          className={`form-control input-select`}
                          filterOption={filterOption}
                          ref={ip[ipLen]}
                          styles={{
                            ...SelectStyles,
                            control: (base, state) => ({
                              ...base,
                              boxShadow: state.isFocused
                                ? "0px 0px 10px -3px var(--primary)"
                                : 0,
                              borderRadius: 10,
                              border: cell ? cell.style.border : 0,
                            }),
                          }}
                          autoFocus={n % headers.length === 0}
                          options={dtl.values.map((i) => ({
                            label: i,
                            value: i,
                          }))}
                          value={{ value, label: value }}
                          onKeyDown={(event) =>
                            handlePress &&
                            handlePress(
                              event,
                              ipLen,
                              validation,
                              row,
                              searchValidation
                            )
                          }
                          onKeyUp={(event) => {
                            handlePress &&
                              handlePress(
                                event,
                                ipLen,
                                validation,
                                row,
                                searchValidation
                              );
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.value || "",
                                focusOn: (num) => {
                                  ip[ipLen + num] &&
                                    ip[ipLen + num].current.focus();
                                },
                              });
                          }}
                          onChange={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.value || "",
                                focusOn: (num) => {
                                  ip[ipLen + num] &&
                                    ip[ipLen + num].current.focus();
                                },
                              });
                            handlePress &&
                              handlePress(
                                event,
                                ipLen,
                                validation,
                                row,
                                searchValidation
                              );
                          }}
                        />
                      </td>
                    );
                  } else if (datePicker) {
                    return (
                      <td key={`${index}-${n}`}>
                        <AppDatePicker
                          list={
                            dataList &&
                            dataList.filter(
                              ({ name: dataName }) => dataName === name
                            )[0]?.name
                          }
                          ref={ip[ipLen]}
                          autoFocus={n % headers.length === 0}
                          autoComplete="off"
                          className="form-control"
                          value={value}
                          name={name}
                          onClick={() => {
                            onClick && onClick();
                          }}
                          readOnly={!edit || readOnly}
                          onKeyDown={(event) =>
                            handlePress &&
                            handlePress(event, ipLen, validation, row)
                          }
                          onKeyUp={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                focusOn: (num) => {},
                              });
                          }}
                          onChange={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                focusOn: (num) => {
                                  ip[ipLen + num] &&
                                    ip[ipLen + num].current.focus();
                                },
                              });
                          }}
                          {...cell}
                          {...rest}
                        />
                      </td>
                    );
                  }
                  return (
                    <td key={`${index}-${n}`}>
                      {multiline && (
                        <textarea
                          rows={1}
                          list={
                            dataList &&
                            dataList.filter(
                              ({ name: dataName }) => dataName === name
                            )[0]?.name
                          }
                          ref={ip[ipLen]}
                          autoFocus={n % headers.length === 0}
                          autoComplete="off"
                          className="form-control"
                          value={value}
                          style={cell && { ...cell.style }}
                          name={name}
                          onClick={() => {
                            onClick && onClick();
                          }}
                          readOnly={!edit || readOnly}
                          onKeyDown={(event) =>
                            handlePress &&
                            handlePress(
                              event,
                              ipLen,
                              validation,
                              row,
                              false,
                              multiline
                            )
                          }
                          onKeyUp={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                noDigits,
                                focusOn: (num) => {
                                  // ip[ipLen + 1] && ip[ipLen + 1].current.focus();
                                },
                              });
                          }}
                          onChange={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                noDigits,
                                focusOn: (num) => {
                                  ip[ipLen + num] &&
                                    ip[ipLen + num].current.focus();
                                },
                              });
                          }}
                          {...rest}
                        ></textarea>
                      )}
                      {!multiline && (
                        <input
                          list={
                            dataList &&
                            dataList.filter(
                              ({ name: dataName }) => dataName === name
                            )[0]?.name
                          }
                          ref={ip[ipLen]}
                          autoFocus={n % headers.length === 0}
                          autoComplete="off"
                          className="form-control"
                          value={value}
                          style={cell && { ...cell.style }}
                          name={name}
                          onClick={() => {
                            onClick && onClick();
                          }}
                          readOnly={!edit || readOnly}
                          onKeyDown={(event) =>
                            handlePress &&
                            handlePress(event, ipLen, validation, row)
                          }
                          onKeyUp={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                noDigits,
                                focusOn: (num) => {
                                  // ip[ipLen + 1] && ip[ipLen + 1].current.focus();
                                },
                              });
                          }}
                          onChange={(event) => {
                            onInputChange &&
                              onInputChange({
                                event,
                                row: index,
                                column: n,
                                name: headers[n].name,
                                numberFormat,
                                value: event.currentTarget.value,
                                noDigits,
                                focusOn: (num) => {
                                  ip[ipLen + num] &&
                                    ip[ipLen + num].current.focus();
                                },
                              });
                          }}
                          {...rest}
                        />
                      )}
                    </td>
                  );
                })}
                {SideButtons && (
                  <td className="side-td">
                    <SideButtons row={row} column={index} />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <p style={{ color: "gray" }}>{helpText}</p>
    </div>
  );
}
